import { HttpError } from '$lib/HttpError';
import { logger } from '$lib/logger.js';
import { getLaunch, getLaunches } from '$lib/utils/launchClient';
import { LaunchesApiClient } from '$lib/utils/public-resources/launches/LaunchesApiClient';
import { error } from '@sveltejs/kit';

export async function load({ params, fetch }) {
  var isLoading = false;

  const idLaunch = params.idLaunch;
  const publicResources = new LaunchesApiClient(fetch);

  try {
    logger.info({ launchId: idLaunch }, 'Loading launch details');
    const launch = await getLaunch(fetch, idLaunch);

    logger.info(`Loading public resources of launch ${idLaunch}`);
    const launchPublicResources = await publicResources.getLaunch(idLaunch);
    const relatedLaunches = await loadRelatedLaunches(fetch, idLaunch, launch);

    isLoading = false;

    return { launch, relatedLaunches, isLoading, launchPublicResources: launchPublicResources };
  } catch (e) {
    if (e instanceof HttpError) {
      switch (e.status) {
        case 404:
          error(e.status, 'No such launch');
      }
    }
    const errorMsg = 'Failed to load launch details';
    logger.error(e, errorMsg);
    error(500, errorMsg);
  }
}

async function loadRelatedLaunches(
  fetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>,
  idLaunch: string,
  launch: import('$lib/types/launch.js').Launch
) {
  const launches = await getLaunches(fetch, 0, 6, false, launch.type ? [launch.type] : []);
  return launches.data.filter(
    (launch: import('$lib/types/launch.js').Launch) => launch.id !== idLaunch
  );
}
